module.exports = "/_next/static/images/top-95f83b1a1cb4618a64f5226aac2b91d7.jpg";